import { useState, useEffect } from "react";
import BannerMobile from "../../components/banner/bannerMobile";
import CardMobile1 from "../../components/card/cardMobile1";
import CardMobile2 from "../../components/card/cardMobile2";
import CardMobile3 from "../../components/card/cardMobile3";
import CardMobile4 from "../../components/card/cardMobile4";
import CardMobile5 from "../../components/card/cardMobile5";
import CardMobile6 from "../../components/card/cardMobile6";
// import CardMobile7 from "../../components/card/cardMobile7";
import CardMobile8 from "../../components/card/cardMobile8";

function HomeMobile() {
  const [data, setData] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch("./dataV2.json");
        if (response.ok) {
          const dataV2 = await response.json();
          setData(dataV2);
        } else {
          console.error("Failed to load data");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchData();
  }, []);

  if (!data) {
    // Afficher un indicateur de chargement pendant la récupération des données
    return <div>Loading...</div>;
  }

  const {
    dataHeader: banner,
    dataMainCard1: yoga,
    dataMainCard21: athlete1,
    dataMainCard22: athlete2,
    dataMainCard3: coach,
    dataMainCard4: numberKey,
    dataMainCard5: etirement,
    dataMainCard6: session,
    // dataMainCard7: app,
  } = data;

  return (
    <>
      <BannerMobile key="banner" banner={banner} />
      <div className="main">
        <CardMobile1 yoga={yoga} />
        <CardMobile2 athletes1={athlete1} athletes2={athlete2} />

        <CardMobile3 coach={coach} />
        <CardMobile4 numberKey={numberKey} />
        <CardMobile5 etirement={etirement} />
        <CardMobile6 session={session} />
        {/*
        <CardMobile7 app={app} />
        */}
        <CardMobile8 />
      </div>
    </>
  );
}

export default HomeMobile;
